import React from "react";
import './Blogs.css'

const Blogs = () => {
  return (
    <div>
      <div className="q-1">
        <h1>What is context API?</h1>
        <p>
          Ans: The React Context API is a way for react app to effectively
          produce global variables that can be passed around. This is
          alternative to prop drilling or moving props from grandparent to child
          parent, and so on. Context is also touted as an easier, lighter
          approach to state management using Redux. Context API is a new feature
          added in version 16.3 of React. That allows to share state across the
          entire app lightly and with ease.
        </p>
      </div>
      <div className="q-2">
        <h1>What is Semantic tag?</h1>
        <p>
          Ans: HTML was originally created as a markup language to describe
          documents on the early internet. As the internet grew and was adopted
          by more people. Its Need change. Where the internet was originally
          intended for sharing scientific documents, now people wanted to share
          other things as well. Very quickly, people started wanting to make the
          web look nicer. As the use of visually designed layouts progress ,
          programmers started to use a generic non-semantic tag like div. They
          would often give these elements a class or id attribute to describe
          their purpose. For example, instead of header this was often written
          as div class=header.
        </p>
      </div>
    </div>
  );
};

export default Blogs;
